import { render, staticRenderFns } from "./StudipFiveStars.vue?vue&type=template&id=11ee6d9e&"
import script from "./StudipFiveStars.vue?vue&type=script&lang=js&"
export * from "./StudipFiveStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports